
import { Component, Prop, Vue } from "vue-property-decorator"

@Component({
})
export default class TextDisplayWithCopy extends Vue {
	@Prop({ type: String, required: true })
	value!: string

	@Prop({ type: Boolean, default: false })
	displayValue!: boolean

	public copiedItems: string = ""

	public get textValue () : string {
		return this.value || ""
	}

	public async copyValue () {
		if (this.textValue) {
			const type = "text/plain"
			const blob = new Blob([this.textValue], { type: type })
			try {
				// @ts-ignore
				await navigator.clipboard.write([new ClipboardItem({ [type]: blob })])
				this.copiedItems = "Copied!"
			} catch (err) {
				console.error("Failed to copy text:", err)
				this.copiedItems = "Failed to copy: " + this.textValue
			}
		}
	}
}

